<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" :style="{height:screenHeight}">
        <div class="modal-container" @click.stop :class="{bigModal : setModalStyle.bigModal, longHeight : setModalStyle.longHeight, specialPick : setModalStyle.specialPick, topImg : setModalStyle.topImg}">
          <div class="modal-header">
            <slot name="header">
              default header
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              default footer
              <button class="modal-default-button" @click="SET_POPUP(false)">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { hasNotch, NOTCH_HEIGHT } from '../utils/checkDevice'
import { mapState, mapMutations } from 'vuex'
export default {
  props: {
    setModalStyle: {
      bigModal: false,
      longHeight: false,
      specialPick: false,
      topImg: false,
      url: ''
    }
  },
  data () {
    return {
      bigModal: this.setModalStyle.bigModal,
      longHeight: this.setModalStyle.longHeight,
      specialPick: this.setModalStyle.specialPick,
      topImg: this.setModalStyle.topImg
    }
  },
  computed: {
    ...mapState([
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ])
  },
  created () {
    this.screenHeight = hasNotch() ? (screen.height - NOTCH_HEIGHT) + 'px' : screen.height + 'px'
  }
}
</script>

<style lang="scss" scoped>

</style>
